import React, { CSSProperties, FC, PropsWithChildren } from "react";

import styled from "styled-components";

type SectionDisplayerProps = {
    title: string;
    dataTestId?: string;
    style?: CSSProperties;
};

const SectionDisplayerHeader = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 16px;
    font-size: var(--size-16);
    font-style: normal;
    font-weight: bold;
    line-height: 25px;
    color: var(--color-primary);
    text-transform: uppercase;
    background-color: var(--color-secondary-light);
    border-radius: var(--radius-top-10);
`;
const SectionDisplayerBody = styled.div`
    padding: 16px;
    background-color: var(--color-white);
    border-radius: var(--radius-bottom-10);
`;

const SectionDisplayer: FC<PropsWithChildren<SectionDisplayerProps>> = ({ title, children, style, dataTestId }) => {
    return (
        <div style={style} className="sectionDisplayer" data-testid={dataTestId}>
            <SectionDisplayerHeader className="header">{title}</SectionDisplayerHeader>
            <SectionDisplayerBody className="body">{children}</SectionDisplayerBody>
        </div>
    );
};

export default SectionDisplayer;
